import axios from "axios";
import { useCallback, useEffect, useRef, useState } from "react";

export const fetchDataFromApi = async (url, params) => {
    try {
        const { data } = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
            params,
        });
        console.log(data);
        return data
    } catch (error) {
        console.log(error);
        return error;
    }
}

export const postDataToTheServer = async (url, params) => {
    try {
        const { data } = await axios.post(url, params, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            }, params,
        });
        return data;
    } catch (error) {
        console.log(error.response.data);
        return error.response.data;
    }
}



export const patchDataToTheServer = async (url, params) => {
    try {
        const { data } = await axios.patch(url, params, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            }, params,
        });
        return data;
    } catch (error) {
        console.log(error.response.data);
        return error.response.data;
    }
}

export const postFileToTheServer = async (url, params) => {
    try {
        const { data } = await axios.post(url, params, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                'Content-Type': 'multipart/form-data',
            }, params,
        });

        return data;
    } catch (error) {
        console.log(error.response.data);
        return error.response.data;
    }
}
export const putDataToTheServer = async (url, params) => {
    try {
        const { data } = await axios.put(url, params, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            }, params,
        })
        return data;
    } catch (error) {
        console.log(error.response);
        return error.response;
    }
}

export const deleteDataToTheServer = async (url, params) => {
    try {
        const { data } = await axios.delete(url, params, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            }, params,
        })
        return data;
    } catch (error) {
        console.log(error.response.data);
        return error.response.data;
    }
}

const useFetch = (url, options = {}) => {
    const {
        params = {},
        immediate = true,
        initialData = null,
        deps = [],
    } = options;

    const [data, setData] = useState(initialData);
    const [loading, setLoading] = useState(immediate);
    const [error, setError] = useState(null);

    // Keep a stable ref to the AbortController so `cancel()` always works
    const abortRef = useRef(null);

    const fetchData = useCallback(
        async (overrideParams = {}) => {
            abortRef.current?.abort();
            abortRef.current = new AbortController();

            setLoading(true);
            setError(null);

            try {
                const { data: responseData } = await axios.get(url, {
                    params: { ...params, ...overrideParams },
                    signal: abortRef.current.signal,
                });

                setData(responseData);
                return responseData;
            } catch (err) {
                const normaliseError = normaliseError(err);

                // Don't update state for cancelled requests
                if (!normaliseError.cancelled) setError(normaliseError);

                return null;
            } finally {
                setLoading(false);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [url, JSON.stringify(params), ...deps]
    );

    // Cancel on unmount to prevent state updates on dead components
    useEffect(() => {
        return () => abortRef.current?.abort();
    }, []);

    useEffect(() => {
        if (immediate) fetchData();
    }, [fetchData, immediate]);

    const cancel = useCallback(() => abortRef.current?.abort(), []);

    return { data, loading, error, refetch: fetchData, cancel };
};

export default useFetch;
